import { getUserId } from '@/helpers/auth/auth';
import { isAutotest } from '@/helpers/autotest/autotest';
import { parseCookie } from '@/helpers/cookie/cookie';
import { isParamNtf } from '@/helpers/navigator/navigator';
import { growthbookApi } from '@/services/api/growthbook/growthbook';
import { setClarityTag } from '@/services/clarity/clarity';

export type GrowthBookFeatures = {
  // 'welcome-popup': 'v1' | 'v2';
  // 'paypal-first-split': 'v1' | 'v2';
  // 'trial-prosperi2': 'v1' | 'v2';
  // 'trial-prosperi3': 'v1' | 'v2';
  // 'paypal-improve': 'v1' | 'v2';
  // 'trial-prosperi': 'v1' | 'v2';
  // webview: 'v1' | 'v2';
  // 'big-search': 'v1' | 'v2';
  // gpay2: 'v1' | 'v2' | 'def';

  // 'no-welcome': 'v1' | 'v2' | 'def';

  //https://gdx.myjetbrains.com/youtrack/issue/GDP-4050/Close-split-ntf21
  // ntf21: 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3853/Close-split-like-popup
  // 'like-popup': 'v1' | 'v2' | 'v3' | 'v4' | 'def';

  'pr-aa': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3913/Close-split-merge-notif2
  // 'merge-notif2': 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3864/No-Engagement-Test
  // CLOSED in v1: 'no-engag': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3806/Onboarding-Android-veb-view-photo
  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3895/EndTest-Onboarding-android-upload
  // 'android-upload': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3922/NTF-Deactivation-by-Support
  // deactivate: 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4086/Close-split-deactivate2
  // deactivate2: 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-3790/frontend-Trial-Expiration-Reminder-Welcome-Popup
  // reminder: 'ntf-v2' | 'trf-v2' | 'def';

  // CLOSED in v1: 'hide-geo': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4205/Project-EM-1010
  // CLOSED in v1: 'project-em': 'v1' | 'v2' | 'v3' | 'v4' | 'v5' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4470/Split-Buttons-redesign
  // deactivate: 'buttons-redesign': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4582/frontend-Split-Germany-VAT-Paywall
  // CLOSED in v1: 'de-paywall': 'v1' | 'v2' | 'v3' | 'def';

  // CLOSED in v2: 'whitelist-cleanup': 'v1' | 'v2' | 'def';

  // CLOSED in v1: 'adopt-ftc-rules-2': 'v1' | 'v2' | 'v3' | 'v4' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4752/Splitfrontend-Limited-Search
  // CLOSED in v1: 'limited-search-bandit': 'v1' | 'v2' | 'v3' | 'def';

  // CLOSED in v1: 'ai-autoactivity': 'v1' | 'v2' | 'v3' | 'v4' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4791
  // CLOSED in v1: 'clear-credits-2': 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4782/Splitfrontend-PWA-installation-banner
  // CLOSED in v1: 'pwa-banner': 'v1' | 'v2' | 'v3' | 'def';

  'pwa-placements': 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4008/Apple-Pay-on-all-desktop-browsers
  // CLOSED in v2:
  // 'apple-pay-all': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4827/frontend-Split-Pricing-40-40
  // 'pricing-40-40': 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4590/frontend-Split-Geo-Distance
  // 'geo-distance': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4322/Trustpilot-Top-of-Funnel
  // review: 'v1' | 'v2' | 'def';

  // CLOSED in v1: https://gdx.myjetbrains.com/youtrack/issue/GDP-4981/Split-Checkout-on-paywall
  // 'checkout-paywall': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5059/frontend-Introduce-1-fee-before-transaction-for-cards
  'authorization-fee': 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5072/Split-1-lifetime-subscription-on-cancellation-flow
  // CLOSED in v1: 'cancel-upsell-vamp': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5061/fronted-Show-currency-code-as-US
  // CLOSED in v1: 'currency-compliance': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-4946/Secret-landing
  'lp-2': 'sct-v1' | 'sct-v2' | 'sct-v3' | 'def';

  'lp-de': 'chat-de-v1' | 'chat-de-v2' | 'chat-de-v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5201/Splitfrontend-User-Precise-Location
  // CLOSED in v1: 'precise-location': 'v1' | 'v2' | 'v3' | 'def';

  // CLOSED in v1: 'boost-promo-prem': 'v1' | 'v2' | 'v3' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5814/Split-Cancellation-Flow-4
  'cancel-flow-4': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5198/frontend-User-Profile-Renovation
  // CLOSED in v1: 'profile-renovation': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5346/EpicSplit-Swipe-search-for-R2R-Iteration-12
  // CLOSED in v1: 'swipe-search-r2r': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5801/Create-primer-form-mvp
  primer: 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5845/Split-Default-premium-package-3m
  // CLOSED in v1: 'default-3m': 'v1' | 'v2' | 'def';

  // CLOSED in v1: 'weekly-packages-retest': 'v1' | 'v2' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5493/MMA-Prioritization-by-payment-method
  geo_payment_prioritization: 'disable-gpay' | 'disable-apay' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-6012/auto-trustpilot-new-placements
  // CLOSED in v3: 'trustpilot-new-placements': 'v1' | 'v2' | 'v3' | 'v4' | 'v5' | 'v6' | 'def';

  // https://gdx.myjetbrains.com/youtrack/issue/GDP-5822/Epic-Sequel-Transfer-users-from-MMA
  'mma-sequel-promo': 'v1' | 'v2' | 'v3' | 'v4' | 'def';
};

export type GrowthBookAttributesGender = 'male' | 'female';

export type GrowthBookAttributes = {
  userId: string;
  isNtf: boolean;
  regDateUnix?: number;
  lp_t?: string;
  lp_utm_source?: string;
  gender?: GrowthBookAttributesGender;
  countryAlpha2?: string;
  countryAlpha3?: string;
  isNewYorkCity?: boolean;
  isOrganic?: boolean;
  isPremiumActive?: boolean;
  isPremium?: boolean;
};

const memoryCacheMap: Record<string, unknown> = {};

// Just use this method, don't run any init methods before.
export async function getGrowthBookFeatureValue<T extends keyof GrowthBookFeatures>(
  featureName: T,
  defaultValue: GrowthBookFeatures[T],
  attributeAdditionalList?: Partial<GrowthBookAttributes>,
): Promise<GrowthBookFeatures[T]> {
  const cookieList = parseCookie(document.cookie);
  const featureValue = cookieList[`gdx_split_${featureName}`];

  if (featureValue) {
    return featureValue as GrowthBookFeatures[T];
  } else if (isAutotest()) {
    return 'def';
  } else if (memoryCacheMap[featureName]) {
    setClarityTag(featureName, memoryCacheMap[featureName] as string);

    return memoryCacheMap[featureName] as GrowthBookFeatures[T];
  }

  const response = await growthbookApi.listFeaturesWithAttributes({
    attributeMap: {
      userId: getUserId(),
      isNtf: isParamNtf(),
      ...attributeAdditionalList,
    },
    featureList: [featureName],
  });

  const featureMap: Partial<GrowthBookFeatures> = Object.fromEntries(
    response.features.map((feature) => {
      return [feature.name, feature.value?.val.value];
    }),
  );

  setClarityTag(featureName, featureMap[featureName] as string);

  if (!featureMap[featureName]) {
    return defaultValue;
  }

  memoryCacheMap[featureName] = featureMap[featureName];

  return featureMap[featureName] as GrowthBookFeatures[T];
}
